<template>
  <div
    v-if="!isMobile"
    class="carmelCapital-background-wrapper"
  >
    <div
      v-for="(bg, index) in bgImages"
      :key="index"
      class="carmelCapital-bg-slide"
      :class="{ active: currentBgIndex === index }"
      :style="{ backgroundImage: `linear-gradient(135deg, rgba(26, 35, 50, 0.55) 0%, rgba(26, 35, 50, 0.3) 35%, rgba(20, 20, 20, 0.75) 70%, rgba(10, 10, 10, 0.95) 100%), url(${bg})` }"
    ></div>
    <div class="carmelCapital-content-left">
      <div class="carmelCapital-hero-section">
        <img :src="logoUrl" class="carmelCapital-logo-hero" alt="Carmel Capital" />

      </div>
    </div>
  </div>
  <header
    v-if="!isMobile && possuiLogoEsquerdaTopo"
    :class="{ siteHeaderUBS: true }"
    class="siteHeader"
  >
    <div class="logo">
      <img
        :src="logoUrl"
        :class="{
          logoHeader_ubs: true,
        }"
      />
    </div>
  </header>
  <div class="site-header" v-if="possuiBotaoCadastroTopo || isMobile">
    <nav class="navigation">
      <ul>
        <li>
          <button
            type="button"
            @click="irParaCadastroInicial"
            class="submit-button-login"
          >
            Cadastro
          </button>
        </li>
      </ul>
    </nav>
  </div>

  <div
    class="container"
    :class="{
      containerUBS: isUBS,
    }"
    :style="isMobile ? ubsBackgroundStyle : {}"
  >
    <div v-if="!openToken" class="header">
      <h2 v-if="!isGenial">Selecione o tipo de conta</h2>
    </div>

    <div v-if="openToken" class="header">
      <p
        style="
          cursor: pointer;
          margin-top: 10px;
          align-self: flex-start;
          cursor: pointer;
          display: inline-flex;
        "
        @click="voltar()"
      >
        <img src="@/assets/arrow.svg" /> Voltar
      </p>
      <div>
        <img src="@/assets/cadeado_com_fundo.svg" />
      </div>
      <h2 style="color: #00235c; font-size: 30px">Chave de acesso</h2>
    </div>
    <div class="tabs-container" v-if="!openToken">
      <div
        class="tab-item"
        v-if="verificarTipoCliente('1')"
        :class="{ active: tab === 1 }"
      >
        <a href="javascript:;" class="link" @click="selectTab(1)">
          PESSOA FÍSICA
        </a>
        <div class="underline"></div>
      </div>
      <div
        class="tab-item"
        v-if="verificarTipoCliente('2')"
        :class="{ active: tab === 2 }"
      >
        <a href="javascript:;" class="link" @click="selectTab(2)">
          PESSOA JURÍDICA
        </a>
        <div class="underline"></div>
      </div>
      <div
        class="tab-item"
        v-if="verificarTipoCliente('3')"
        :class="{ active: tab === 3 }"
      >
        <a href="javascript:;" class="link" @click="selectTab(3)"> FUNDOS </a>
        <div class="underline"></div>
      </div>
    </div>
    <div class="header" style="margin-top: 0; padding-top: 20px">
      <p v-if="!openToken" style="margin-top: 0">{{ mensagemLoginHeader }}</p>

      <p v-if="openToken" style="margin-top: 0">
        Para continuar, digite o código que acabamos de enviar para o seu
        e-mail.
      </p>
      <template v-if="openToken && emailProviderInfo">
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            margin-top: 8px;
          "
        >
          <a
            :href="gmailMobileLink || emailProviderInfo.link"
            target="_blank"
            style="
              color: #6e6e6e;
              display: flex;
              align-items: center;
              gap: 4px;
              text-decoration: none;
            "
          >
            <img
              :src="emailProviderInfo.icon"
              :alt="emailProviderInfo.name"
              style="width: 22px; height: 22px; vertical-align: middle"
            />
            <span style="font-size: 0.97em; font-weight: 500"
              >Abrir {{ emailProviderInfo.name }}</span
            >
          </a>
        </div>
      </template>
    </div>
    <!-- Formulário unificado para PF, PJ e Fundos -->
    <form v-if="!openToken" class="form" @submit.stop.prevent="sendLogin">
      <fieldset
        v-if="tab === 2 || tab === 3"
        :disabled="loading"
        style="border: none"
      >
        <!-- Tabs 2 (PJ) e 3 (Fundos) -->
        <div class="input-field">
          <label for="email">E-mail ou CNPJ</label>
          <input
            type="text"
            v-model="loginSession.Usuario"
            class="field"
            autocomplete="off"
            @click.stop.prevent="clear"
            :ref="tab === 2 ? 'emailField2' : 'emailField3'"
            :class="{
              erroBorder: erro,
              erroBorderVerifyRegister: erro && tab === 2,
            }"
            @blur="handleEmailBlur"
            @input="onEmailInput"
          />
          <ul
            v-if="showSuggestions && loginSession.Usuario"
            class="email-suggestions"
          >
            <li
              v-for="suggestion in filteredSuggestions"
              :key="suggestion"
              @mousedown.prevent="applySuggestion(suggestion)"
            >
              {{ loginSession.Usuario + suggestion }}
            </li>
          </ul>
        </div>
        <div class="input-field" v-if="configuracaoApelido == 'S'">
          <label for="apelido">Selecione o apelido da conta para logar</label>
          <select
            v-model="loginSession.Apelido"
            class="field"
            :class="{ erroBorder: erro }"
            style="margin-bottom: 20px"
            :disabled="isApelidoDisabled"
          >
            <option v-for="apelido in apelidos" :key="apelido" :value="apelido">
              {{ apelido }}
            </option>
          </select>
        </div>
        <div class="input-field" v-if="modoAutenticacao != 2">
          <label for="password">Senha</label>
          <input
            type="password"
            v-model="loginSession.Senha"
            class="field"
            autocomplete="off"
            @click.stop.prevent="clear"
            :class="{ erroBorder: erro }"
          />
        </div>
        <button
          type="button"
          @click="reenviarEmail"
          v-if="habilitarReenviarEmail"
          class="button buttonReenviarEmail"
        >
          Reenviar e-mail para ativação
        </button>
        <router-link
          class="forgot-password"
          v-if="modoAutenticacao != 2"
          to="/RecuperarSenha"
          >Esqueci minha senha</router-link
        >
        <button
          type="submit"
          v-if="modoAutenticacao != 2"
          :disabled="disableBtnLogin"
          :class="{ disabledBtn: disableBtnLogin }"
          class="submit-button-login"
        >
          <span class="btnText" v-if="!disableBtnLogin">Entrar</span>
          <div class="loadingDots" v-if="disableBtnLogin">
            <span class="dot">.</span>
            <span class="dot2">.</span>
            <span class="dot3">.</span>
          </div>
        </button>
        <button
          type="button"
          @click="sendLogin()"
          v-if="modoAutenticacao == 2"
          :disabled="disableBtnLogin"
          :class="{ disabledBtn: disableBtnLogin }"
          class="submit-button-login"
        >
          <span class="btnText" v-if="!disableBtnLogin">Avançar</span>
          <div class="loadingDots" v-if="disableBtnLogin">
            <span class="dot">.</span>
            <span class="dot2">.</span>
            <span class="dot3">.</span>
          </div>
        </button>
      </fieldset>
      <template v-else>
        <!-- Tab 1 (PF) -->
        <div class="input-field">
          <label for="email">E-mail ou CPF</label>
          <input
            type="text"
            v-model="loginSession.Usuario"
            class="field"
            autocomplete="off"
            @click.stop.prevent="clear"
            :class="{ erroBorder: erro }"
            @input="onEmailInput"
            ref="emailField1"
          />
          <ul
            v-if="showSuggestions && loginSession.Usuario"
            class="email-suggestions"
          >
            <li
              v-for="suggestion in filteredSuggestions"
              :key="suggestion"
              @mousedown.prevent="applySuggestion(suggestion)"
            >
              {{ loginSession.Usuario + suggestion }}
            </li>
          </ul>
        </div>
        <div class="input-field" v-if="modoAutenticacao != 2">
          <label for="password">Senha</label>
          <input
            type="password"
            v-model="loginSession.Senha"
            class="field"
            autocomplete="off"
            @click.stop.prevent="clear"
            :class="{ erroBorder: erro }"
          />
        </div>
        <button
          type="button"
          @click="reenviarEmail"
          v-if="habilitarReenviarEmail"
          class="button buttonReenviarEmail"
        >
          Reenviar e-mail para ativação
        </button>
        <router-link class="forgot-password" to="/RecuperarSenha"
          >Esqueci minha senha</router-link
        >
        <button
          type="submit"
          :disabled="disableBtnLogin"
          :class="{ disabledBtn: disableBtnLogin }"
          class="submit-button-login"
        >
          <span class="btnText" v-if="!disableBtnLogin">Entrar</span>
          <div class="loadingDots" v-if="disableBtnLogin">
            <span class="dot">.</span>
            <span class="dot2">.</span>
            <span class="dot3">.</span>
          </div>
        </button>
      </template>
    </form>
    <form
      class="form"
      v-if="openToken"
      @submit.stop.prevent="sendLoginWithToken"
    >
      <div class="input-field">
        <div class="token-input-group">
          <input
            v-for="n in 6"
            :key="n"
            :ref="'tokenInput' + (n - 1)"
            type="text"
            inputmode="numeric"
            maxlength="1"
            class="token-box"
            :class="{ erroBorder: erro }"
            @input="onTokenInput($event, n - 1)"
            @keydown.backspace="onTokenBackspace($event, n - 1)"
            v-model="tokenBoxes[n - 1]"
            autocomplete="one-time-code"
            @paste="n === 1 ? onTokenPaste($event) : null"
          />
        </div>
      </div>
      <button
        type="button"
        @click="sendLoginWithToken()"
        :disabled="disableBtnLogin"
        :class="{ disabledBtn: disableBtnLogin }"
        class="submit-button-login"
      >
        <span class="btnText" v-if="!disableBtnLogin">Avançar</span>
        <div class="loadingDots" v-if="disableBtnLogin">
          <span class="dot">.</span>
          <span class="dot2">.</span>
          <span class="dot3">.</span>
        </div>
      </button>

      <div class="reenviar-token-wrapper" v-if="openToken">
        <button
          type="button"
          class="reenviar-token-btn"
          :disabled="!reenviarTokenDisponivel"
          @click="reenviarToken"
        >
          Reenviar token
        </button>
        <span v-if="!reenviarTokenDisponivel" class="reenviar-token-desc">
          Disponível em {{ reenviarTokenTimer }} segundos
        </span>
      </div>
    </form>
    <div class="footer" v-if="nomeEmpresa != 'GENIAL'">
      <p>
        Ainda não possui conta?
        <router-link to="/CadastroInicio">Cadastre-se</router-link>
      </p>
    </div>
    <p>Versão {{ versaoSistema }}</p>
    <ModalAvisoLogin
      :mensagem="messageError"
      :mensagensComplementares="mensagensComplementares"
    />
    <ModalAvisoPersonalizadoGenial
      v-if="nomeEmpresa == 'GENIAL' && configuracaoModalAprovacaoPersonalizada"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@/api/axios";
import ModalAvisoLogin from "./Login/ModalAvisoLogin.vue";
import ModalAvisoPersonalizadoGenial from "./Login/ModalMensagemPersonalizadaAprovacao.vue";
import SHA256 from "crypto-js/sha256";

// Constantes para validação
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const CNPJ_REGEX = /^(\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})$/;
const CPF_REGEX = /^(\d{3}\.?\d{3}\.?\d{3}-?\d{2})$/;

export default {
  name: "UserLogin",
  components: {
    ModalAvisoLogin,
    ModalAvisoPersonalizadoGenial,
  },
  data() {
    return {
      tab: 1,
      loginSession: {
        Usuario: null,
        Senha: null,
        Token: null,
        Hash: null,
        Apelido: null,
      },
      showSuggestions: false,
      emailSuggestions: [
        "@gmail.com",
        "@outlook.com",
        "@hotmail.com",
        "@yahoo.com",
      ],
      filteredSuggestions: [],
      tokenBoxes: Array(6).fill(""),
      apelidos: [],
      disableBtnLogin: false,
      messageError: null,
      mensagensComplementares: false,
      erro: false,
      openToken: false,
      habilitarReenviarEmail: false,
      nomeEmpresa: "",
      loading: false,
      tiposClientes: [],
      configuracaoTiposClientes: {},
      configuracaoDuplaAutenticacao: false,
      configuracaoModalAprovacaoPersonalizada: false,
      configuracaoURLEntrar: "",
      configuracaoApelido: "",
      isApelidoDisabled: false,
      isMobile: false,
      modoAutenticacao: 0,
      reenviarTokenDisponivel: false,
      reenviarTokenTimer: 30,
      reenviarTokenInterval: null,
      currentBgIndex: 0,
      bgImages: [
        require('@/assets/carmelCapital/fundo1.png'),
        require('@/assets/carmelCapital/fundo2.jpg'),
        require('@/assets/carmelCapital/fundo3.png'),
        require('@/assets/carmelCapital/fundo4.png'),
        require('@/assets/carmelCapital/fundo5.png'),
      ],
      bgTransitionTimer: null,
    };
  },
  computed: {
    gmailMobileLink() {
      if (!this.openToken || !this.emailProviderInfo) return null;
      const isGmail = this.emailProviderInfo.name === "Gmail";
      if (!isGmail) return null;
      // Detecta se é mobile
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const isAndroid = /android/i.test(ua);
      const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      if (isAndroid) {
        return "intent://#Intent;package=com.google.android.gm;scheme=mailto;end";
      }
      if (isIOS) {
        return "googlegmail://";
      }
      return null;
    },
    emailProviderInfo() {
      const email = this.loginSession?.Usuario || "";
      const match = email.match(/@([\w.-]+)$/);
      if (!match) return null;
      const domain = match[1].toLowerCase();
      if (domain === "gmail.com" || domain === "dnways.com") {
        return {
          name: "Gmail",
          link: "https://mail.google.com/",
          icon: require("@/assets/gmail.svg"), // coloque o ícone na pasta assets
        };
      }
      if (
        domain === "outlook.com" ||
        domain === "hotmail.com" ||
        domain === "live.com" ||
        domain === "live.co.uk"
      ) {
        return {
          name: "Outlook",
          link: "https://outlook.live.com/",
          icon: require("@/assets/outlook.svg"), // coloque o ícone na pasta assets
        };
      }
      return null;
    },
    ...mapGetters({
      getConfiguracoes: "GET_CONFIGURACOES",
    }),
    versaoSistema() {
      return process.env.APP_VERSION ?? "";
    },
    mensagemLoginHeader() {
      return process.env.VUE_APP_MENSAGEM_LOGIN_HEADER;
    },
    possuiLogoEsquerdaTopo() {
      return process.env.VUE_APP_POSSUI_LOGO_ESQUERDA == 1 ? true : false;
    },
    logoUrl() {
      return require("@/" + process.env.VUE_APP_URL_LOGO);
    },
    possuiBotaoCadastroTopo() {
      return process.env.VUE_APP_POSSUI_BOTAO_CADASTRAR_TOPO == 1
        ? true
        : false;
    },
    centralizarLogin() {
      return process.env.VUE_APP_CENTRALIZAR_LOGIN == 1 ? true : false;
    },
    // Propriedades computadas para melhorar legibilidade
    isGenial() {
      return this.nomeEmpresa === "GENIAL";
    },
    isRJI() {
      return this.nomeEmpresa === "RJI";
    },
    isActual() {
      return this.nomeEmpresa === "ACTUAL";
    },
    isDnwaysOrBritech() {
      return (
        this.nomeEmpresa === "BRITECH" ||
        this.nomeEmpresa === "DNWAYS_DEMO_Y" ||
        this.nomeEmpresa === "DNWAYS_DEMO_X"
      );
    },
    isVortex() {
      return this.nomeEmpresa === "Vortex";
    },
    isLastro() {
      return this.nomeEmpresa === "Lastro";
    },
    isUBS() {
      return true;
    },
    showApelidoField() {
      return this.configuracaoApelido === "S";
    },
    activeEmailField() {
      return this.tab === 1
        ? "emailField1"
        : this.tab === 2
        ? "emailField2"
        : "emailField3";
    },
    useDuploFator() {
      return this.configuracaoDuplaAutenticacao;
    },
    ubsBackgroundStyle() {
      if (!this.isUBS) return {};

      try {
        const bgImage = this.isMobile
          ? require("@/assets/carmelCapital/fundo1.png")
          : require("@/assets/carmelCapital/fundo1.png");

        return {
          backgroundImage: `
                        linear-gradient(135deg, rgba(26, 35, 50, 0.55) 0%, rgba(26, 35, 50, 0.3) 35%, rgba(20, 20, 20, 0.75) 70%, rgba(10, 10, 10, 0.95) 100%), 
                        url(${bgImage})
                    `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        };
      } catch (error) {
        return {
          background:
            "linear-gradient(135deg, #2ecc71 0%, #1e8449 50%, #1a1a1a 100%)",
        };
      }
    },
  },
  mounted() {
    this.disableBtnLogin = false;
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    this.isMobile = window.innerWidth <= 768;
    this.tab = this.nomeEmpresa != "GENIAL" ? 1 : 2;
    this.$store.commit("SET_MODAL_AVISO_APROVACAO_PERSONALIZADA", false);
    this.$store.commit("SET_MODAL_AVISO_LOGIN", false);

    // Adiciona classe ao body para UBS desktop
    if (this.isUBS && !this.isMobile) {
      document.body.classList.add("carmelCapital-login");
    }

    // Inicia slideshow de fundo rotativo
    if (!this.isMobile) {
      this.bgTransitionTimer = setInterval(() => {
        this.currentBgIndex = (this.currentBgIndex + 1) % this.bgImages.length;
      }, 7000);
    }
  },
  beforeUnmount() {
    // Remove classe ao body quando sair
    document.body.classList.remove("carmelCapital-login");

    if (this.reenviarTokenInterval) {
      clearInterval(this.reenviarTokenInterval);
    }

    if (this.bgTransitionTimer) {
      clearInterval(this.bgTransitionTimer);
    }
  },
  async created() {
    await this.fetchConfiguracao([
      "Remover tipo de cadastro",
      "Modo de autenticação",
      "Modal de aprovação personalizada",
      "Redirecionamento do botão entrar Onboarding externo",
      "Exibir apelido",
    ]);
    this.configuracaoTiposClientes = this.getConfiguracoes(
      "Remover tipo de cadastro",
    );
    this.modoAutenticacao =
      this.getConfiguracoes("Modo de autenticação")?.Valor ?? 0;
    this.configuracaoDuplaAutenticacao =
      this.getConfiguracoes("Modo de autenticação")?.Valor != "0"
        ? true
        : false;
    this.configuracaoModalAprovacaoPersonalizada =
      this.getConfiguracoes("Modal de aprovação personalizada")?.Valor == "S"
        ? true
        : false;
    this.configuracaoURLEntrar = this.getConfiguracoes(
      "Redirecionamento do botão entrar Onboarding externo",
    ).Valor;
    this.configuracaoApelido = this.getConfiguracoes("Exibir apelido").Valor;
  },
  methods: {
    ...mapActions({
      signIn: "auth/signIn",
      verifyLogin: "auth/verifyLogin",
      verifyStatusRegister: "auth/verifyStatusRegister",
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    onTokenPaste(e) {
      const pasted = (e.clipboardData || window.clipboardData).getData("text");
      if (pasted && pasted.length === 6 && /^\d{6}$/.test(pasted)) {
        for (let i = 0; i < 6; i++) {
          this.tokenBoxes[i] = pasted[i];
        }
        // Move o foco para o último input
        this.$nextTick(() => {
          this.$refs["tokenInput5"][0].focus();
        });
        e.preventDefault();

        setTimeout(() => {
          this.sendLoginWithToken();
        }, 100);
      }
    },
    onTokenInput(e, idx) {
      const value = e.target.value.replace(/\D/g, "");
      this.tokenBoxes[idx] = value;
      if (value && idx < 5) {
        this.$refs["tokenInput" + (idx + 1)][0].focus();
      } else if (idx == 5 && value) {
        this.sendLoginWithToken();
      }
    },
    onTokenBackspace(e, idx) {
      if (!this.tokenBoxes[idx] && idx > 0) {
        this.$refs["tokenInput" + (idx - 1)][0].focus();
      }
    },
    avisoLogin() {
      this.$store.commit("SET_MODAL_AVISO_LOGIN", true);
    },
    avisoLoginAprovadoPersonalizado() {
      this.$store.commit("SET_MODAL_AVISO_APROVACAO_PERSONALIZADA", true);
    },
    reenviarToken() {
      this.reenviarTokenDisponivel = false;
      this.reenviarTokenTimer = 30;
      if (this.reenviarTokenInterval) clearInterval(this.reenviarTokenInterval);
      this.reenviarTokenInterval = setInterval(() => {
        if (this.reenviarTokenTimer > 0) {
          this.reenviarTokenTimer--;
        }
        if (this.reenviarTokenTimer === 0) {
          this.reenviarTokenDisponivel = true;
          clearInterval(this.reenviarTokenInterval);
          this.reenviarTokenInterval = null;
        }
      }, 1000);
      this.sendLogin();
      this.$swal({
        icon: "success",
        title: "Token enviado!",
        text: "Acesse o e-mail cadastrado para visualizar o e-mail.",
      });
    },
    voltar() {
      this.resetLoginSession();
      this.openToken = false;
    },
    resetLoginSession() {
      this.loginSession = {
        Usuario: null,
        Senha: null,
        Token: null,
        Hash: null,
        Apelido: null,
      };
    },
    /**
     * Limpa mensagens de erro
     */
    clear() {
      this.messageError = "";
      this.erro = false;
    },
    async validarPreAutenticacaoModoLoginToken() {
      var model = {
        Usuario: this.loginSession.Usuario,
        Apelido: this.loginSession.Apelido,
        TipoCliente: this.tab,
      };
      await this.verifyStatusRegister(model)
        .then((response) => {
          this.disableBtnLogin = false;
          if (
            response.data?.data?.User.StatusCadastro == 2 &&
            this.nomeEmpresa == "GENIAL"
          ) {
            this.avisoLoginAprovadoPersonalizado();
          } else if (
            response.data.data.User.StatusCadastro == 0 ||
            (response.data.data.User.StatusCadastro == 2 &&
              this.nomeEmpresa != "GENIAL") ||
            (response.data.data.User.StatusCadastro == 3 &&
              this.nomeEmpresa != "GENIAL") ||
            (response.data.data.User.StatusCadastro == 4 &&
              this.nomeEmpresa != "GENIAL")
          ) {
            this.messageError = "";
            this.erro = false;
            this.openToken = true;
          }
        })
        .catch((error) => {
          const msgErro = error?.response?.data?.data?.erros?.[0];
          if (
            msgErro === "MODAL_APROVACAO_PERSONALIZADA." &&
            this.nomeEmpresa == "GENIAL"
          ) {
            this.disableBtnLogin = false;
            this.avisoLoginAprovadoPersonalizado();
            return;
          }

          this.tratamentoErroLogin(error);
        });
    },
    verificarTipoCliente(tipo) {
      return this.tiposClientes.some(
        (cliente) => Number(cliente.value) === Number(tipo),
      );
    },
    selectTab(index) {
      this.resetLoginSession();
      this.tab = index;
      this.$nextTick(() => {
        if (!this.isMobile) {
          if (this.tab === 1) {
            this.$refs.emailField1?.focus();
          } else if (this.tab === 2) {
            this.$refs.emailField2?.focus();
          } else if (this.tab === 3) {
            this.$refs.emailField3?.focus();
          }
        }
      });
    },
    applySuggestion(suffix) {
      this.loginSession.Usuario += suffix;
      this.showSuggestions = false;
      if (this.tab != 1) {
        this.handleEmailBlur();
      }
    },
    onEmailInput() {
      const val = this.loginSession.Usuario;

      const onlyNumbers = val.replace(/\D/g, "");
      // Se for só número e até 14 dígitos, aplica máscara de CNPJ
      if (
        /^\d+$/.test(onlyNumbers) &&
        onlyNumbers.length > 0 &&
        !/[a-zA-Z@]/.test(val)
      ) {
        if (this.tab != 1) {
          this.loginSession.Usuario = this.cnpjMask(onlyNumbers);
          if (onlyNumbers.length === 14 && this.isValidCNPJ(onlyNumbers)) {
            this.handleEmailBlur();
            this.focusNextField();
          }
        } else {
          this.loginSession.Usuario = this.cpfMask(onlyNumbers);
          if (onlyNumbers.length === 11 && this.isValidCPF(onlyNumbers)) {
            this.focusNextField();
          }
        }
      } else {
        // Senão, mantém o valor original (para CPF ou e-mail)
        this.loginSession.Usuario = val;
      }

      // Regex: contém pelo menos uma letra
      const contemLetra = /[a-zA-Z]/.test(val);

      // Só sugere se contiver letra, não tiver @ e tiver pelo menos 3 caracteres
      if (contemLetra && val.length >= 3 && !val.includes("@")) {
        this.filteredSuggestions = this.emailSuggestions;
        this.showSuggestions = true;
      } else {
        this.showSuggestions = false;
      }
    },
    focusNextField() {
      // Seleciona todos os campos interativos visíveis e habilitados do formulário
      const selectors =
        'input:not([disabled]):not([readonly]):not([type="hidden"]), select:not([disabled]):not([readonly]), textarea:not([disabled]):not([readonly])';
      // Se quiser limitar ao formulário atual:
      // const form = this.$el.closest('form');
      // const fields = Array.from(form.querySelectorAll(selectors));
      // Se quiser considerar toda a tela:
      const fields = Array.from(document.querySelectorAll(selectors));
      const currentIndex = fields.findIndex(
        (field) => field === document.activeElement,
      );
      if (currentIndex !== -1 && currentIndex + 1 < fields.length) {
        fields[currentIndex + 1].focus();
      }
    },
    cnpjMask(value) {
      // value deve ser só números!
      value = value.substring(0, 14);

      if (value.length <= 2) return value;
      if (value.length <= 5) return value.replace(/^(\d{2})(\d+)/, "$1.$2");
      if (value.length <= 8)
        return value.replace(/^(\d{2})(\d{3})(\d+)/, "$1.$2.$3");
      if (value.length <= 12)
        return value.replace(/^(\d{2})(\d{3})(\d{3})(\d+)/, "$1.$2.$3/$4");
      return value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2}).*/,
        "$1.$2.$3/$4-$5",
      );
    },
    cpfMask(value) {
      // Remove tudo que não for número
      value = value.replace(/\D/g, "");
      // Aplica a máscara
      if (value.length <= 3) return value;
      if (value.length <= 6) return value.replace(/^(\d{3})(\d+)/, "$1.$2");
      if (value.length <= 9)
        return value.replace(/^(\d{3})(\d{3})(\d+)/, "$1.$2.$3");
      return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{0,2}).*/, "$1.$2.$3-$4");
    },
    isValidCPF(cpf) {
      cpf = cpf.replace(/\D/g, "");
      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
      let sum = 0,
        rest;
      for (let i = 1; i <= 9; i++)
        sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      rest = (sum * 10) % 11;
      if (rest === 10 || rest === 11) rest = 0;
      if (rest !== parseInt(cpf.substring(9, 10))) return false;
      sum = 0;
      for (let i = 1; i <= 10; i++)
        sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      rest = (sum * 10) % 11;
      if (rest === 10 || rest === 11) rest = 0;
      return rest === parseInt(cpf.substring(10, 11));
    },
    isValidCNPJ(cnpj) {
      cnpj = cnpj.replace(/\D/g, "");
      if (cnpj.length !== 14) return false;
      if (/^(\d)\1+$/.test(cnpj)) return false;
      let length = cnpj.length - 2;
      let numbers = cnpj.substring(0, length);
      let digits = cnpj.substring(length);
      let sum = 0;
      let pos = length - 7;
      for (let i = length; i >= 1; i--) {
        sum += numbers.charAt(length - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
      if (result !== parseInt(digits.charAt(0))) return false;
      length = length + 1;
      numbers = cnpj.substring(0, length);
      sum = 0;
      pos = length - 7;
      for (let i = length; i >= 1; i--) {
        sum += numbers.charAt(length - i) * pos--;
        if (pos < 2) pos = 9;
      }
      result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
      return result === parseInt(digits.charAt(1));
    },
    async handleEmailBlur() {
      if (!this.loginSession.Usuario) {
        this.apelidos = [];
        return;
      }
      this.loading = true;
      try {
        if (this.configuracaoApelido == "S") {
          const response = await api.get("/login", {
            params: {
              chaveLogin: this.loginSession.Usuario,
              tipoCliente: this.tab,
            },
          });
          this.apelidos = response.data.data;
          if (this.loginSession.Usuario.includes("@")) {
            this.loginSession.Apelido = null;
            this.isApelidoDisabled = false;
          } else {
            this.loginSession.Apelido =
              this.apelidos.length > 0 ? this.apelidos[0] : null;
            this.isApelidoDisabled = true;
          }
        }
      } catch (error) {
        this.apelidos = null;

        if (error.response.data.descricao) {
          this.messageError = error.response.data.descricao;
          this.avisoLogin();
          this.erro = true;
          this.disableBtnLogin = false;
        }

        console.error("Erro ao buscar apelidos:", error);
      } finally {
        this.loading = false;
      }
    },
    irParaCadastroInicial() {
      this.$router.push({ name: "CadastroInicio" });
    },
    async reenviarEmail() {
      if (this.loginSession.Usuario == "") {
        this.messageError = "Verifique os dados";
        this.erro = true;
        return;
      }
      var model = { Email: this.loginSession.Usuario };
      await api
        .post("/register/email-ativar-conta", model)
        .then((retorno) => {
          if (!retorno.data) {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: `Falha no envio do e-mail. Verifique as credenciais de acesso.`,
            });
          } else {
            this.habilitarReenviarEmail = false;
            this.messageError = "";
            this.erro = false;
            this.$swal({
              icon: "success",
              title: "E-mail enviado!",
              text: "Acesse o e-mail cadastrado para confirmar seu acesso.",
            }).then((result) => {
              if (result.value) {
                this.$router.push({ name: "UserLogin" });
              }
            });
          }
        })
        .catch((error) => {
          this.disableBtn = false;
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: `${error.response.data.descricao}`,
          });
        });
    },
    async sendLoginWithToken() {
      this.disableBtnLogin = true;

      var model = {
        Usuario: this.loginSession.Usuario,
        Senha: this.loginSession.Senha
          ? SHA256(this.loginSession.Senha).toString()
          : "",
        Token: this.loginSession.Token,
        Apelido: this.loginSession.Apelido,
        TipoCliente: this.tab,
        HashToken: this.loginSession.Hash,
      };

      await this.signIn(model)
        .then((response) => {
          this.disableBtnLogin = false;
          if (response.status == 200) {
            this.messageError = "";
            this.erro = false;
            this.$router.replace({
              path: "/",
            });
          }
        })
        .catch(() => {
          this.disableBtnLogin = false;
          this.erro = true;

          this.$swal({
            icon: "error",
            title: "Oops...",
            text: `O Token informado não é válido! Verifique e tente novamente.`,
          });
        });
    },
    exibirErro(mensagem, exibirModal = true) {
      this.disableBtnLogin = false;
      this.messageError =
        mensagem ||
        "Ocorreu um erro desconhecido. Entre em contato com o suporte.";
      this.erro = true;
      if (exibirModal) {
        this.avisoLogin();
      }
      return false;
    },
    validarEntrada() {
      if (!this.loginSession.Usuario) {
        this.exibirErro(
          this.tab != 1
            ? "Preencha os dados de E-mail/CNPJ"
            : "Preencha os dados de E-mail/CPF",
        );
        return false;
      }

      if (this.modoAutenticacao == 2) {
        const usuario = this.loginSession.Usuario;
        if (this.tab != 1) {
          if (
            !usuario ||
            (!EMAIL_REGEX.test(usuario) && !CNPJ_REGEX.test(usuario))
          ) {
            this.messageError = "Verifique os dados";
            this.erro = true;
            this.disableBtnLogin = false;
            this.exibirErro(
              "O CNPJ/E-mail informado é inválido! Verifique os dados e tente novamente.",
            );
            return false;
          }
        } else {
          if (
            !usuario ||
            (!EMAIL_REGEX.test(usuario) && !CPF_REGEX.test(usuario))
          ) {
            this.messageError = "Verifique os dados";
            this.erro = true;
            this.disableBtnLogin = false;
            this.exibirErro(
              "O CPF/E-mail informado é inválido! Verifique os dados e tente novamente.",
            );
            return false;
          }
        }
      }

      if (
        (this.loginSession.Senha == "" || this.loginSession.Senha == null) &&
        this.modoAutenticacao != 2
      ) {
        this.messageError = "Preencha a senha.";
        this.avisoLogin();
        this.erro = true;
        this.disableBtnLogin = false;
        return false;
      } else if (
        this.configuracaoApelido == "S" &&
        this.tab != 1 &&
        (this.loginSession.Apelido == "" || this.loginSession.Apelido == null)
      ) {
        this.messageError = "Preencha o apelido da conta";
        this.avisoLogin();
        this.erro = true;
        this.disableBtnLogin = false;
        return false;
      }

      return true;
    },
    tratamentoErroLogin(error) {
      this.disableBtnLogin = false;
      var erroPrincipal = error.response.data?.data?.erros
        ? error.response.data?.data?.erros[0]
        : error.response.data.data[0];

      if (erroPrincipal == "Cliente com e-mail não validado!") {
        this.habilitarReenviarEmail = true;
      }

      if (erroPrincipal == "Cliente não encontrado!") {
        if (this.isGenial) {
          this.$router.push({ name: "CadastroInicio" });
        } else {
          this.mensagensComplementares = true;
        }
      }

      if (
        erroPrincipal == "Usuário está em processo de análise." &&
        this.isGenial
      ) {
        this.$swal({
          icon: "warning",
          title: "Cadastro enviado para análise!",
          text: "Estamos analisando os dados recebidos. Em breve você receberá novidades no e-mail informado.",
        });
        return;
      }

      this.messageError = erroPrincipal;
      this.avisoLogin();
      this.erro = true;
    },
    async validarPreAutenticacaoModoLoginSenhaToken(model) {
      await this.verifyLogin(model)
        .then((response) => {
          this.disableBtnLogin = false;
          if (response.data.data.Sucesso) {
            this.messageError = "";
            this.erro = false;
            this.openToken = true;
          }
        })
        .catch((error) => {
          this.tratamentoErroLogin(error);
        });
    },
    async validarAutenticacaoSimples(model) {
      await this.signIn(model)
        .then((response) => {
          this.disableBtnLogin = false;
          if (response.status == 200) {
            this.messageError = "";
            this.erro = false;
            this.$router.replace({
              path: "/",
            });
          }
        })
        .catch((error) => {
          this.tratamentoErroLogin(error);
        });
    },
    async sendLogin() {
      this.disableBtnLogin = true;
      this.habilitarReenviarEmail = false;
      this.erro = false;
      this.mensagensComplementares = false;

      if (!this.validarEntrada()) {
        return;
      }

      if (this.modoAutenticacao == 2) {
        this.validarPreAutenticacaoModoLoginToken();
        return;
      }

      var model = {
        Usuario: this.loginSession.Usuario,
        Senha: this.loginSession.Senha
          ? SHA256(this.loginSession.Senha).toString()
          : "",
        Apelido: this.loginSession.Apelido,
        tipoCliente: this.tab,
      };

      if (this.configuracaoDuplaAutenticacao) {
        this.validarPreAutenticacaoModoLoginSenhaToken(model);
      } else {
        this.validarAutenticacaoSimples(model);
      }
    },
  },
  watch: {
    tokenBoxes: {
      handler(val) {
        this.loginSession.Token = val.join("");
      },
      deep: true,
    },
    openToken(newVal) {
      if (newVal) {
        this.reenviarTokenDisponivel = false;
        this.reenviarTokenTimer = 30;
        if (this.reenviarTokenInterval)
          clearInterval(this.reenviarTokenInterval);
        this.reenviarTokenInterval = setInterval(() => {
          if (this.reenviarTokenTimer > 0) {
            this.reenviarTokenTimer--;
          }
          if (this.reenviarTokenTimer === 0) {
            this.reenviarTokenDisponivel = true;
            clearInterval(this.reenviarTokenInterval);
            this.reenviarTokenInterval = null;
          }
        }, 1000);

        this.tokenBoxes = Array(6).fill("");
      } else {
        // Limpa timer se voltar para tela anterior
        if (this.reenviarTokenInterval) {
          clearInterval(this.reenviarTokenInterval);
          this.reenviarTokenInterval = null;
        }
        this.reenviarTokenDisponivel = false;
        this.reenviarTokenTimer = 30;
      }
    },
    configuracaoTiposClientes(newVal) {
      if (newVal && newVal.Valor) {
        const valores = newVal.Valor.replace("\r\n", ";")
          .replace(",", ";")
          .split(";")
          .map((item) => item.trim())
          .filter((item) => item);
        const todasOpcoes = [
          { value: "1", label: "Pessoa Física" },
          { value: "2", label: "Pessoa Jurídica" },
          { value: "3", label: "Fundo de Investimento" },
        ];
        const tiposFiltrados = todasOpcoes.filter(
          (opcao) => !valores.includes(opcao.value),
        );
        if (
          JSON.stringify(tiposFiltrados) !== JSON.stringify(this.tiposClientes)
        ) {
          this.tiposClientes = tiposFiltrados;
        }
      } else {
        if (this.tiposClientes.length > 0) {
          this.tiposClientes = [];
        }
      }
      if (this.tiposClientes.length > 0) {
        this.tab = parseInt(this.tiposClientes[0].value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/carmelcapital.scss";
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");

body,
html {
  height: 100%;
  margin: 0;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
